import { AuthProvider, RecoverPasswordToken as AuthRecoverPasswordTokenPage } from '@hub-la/fe-auth'

export const RecoverPasswordTokenInit = () => {
  return (
    <AuthProvider>
      <AuthRecoverPasswordTokenPage />
    </AuthProvider>
  )
}
